import { countStateTypes } from "./count.types";

// updatingn all count
export const updateCount = (countState) => ({
  type: countStateTypes.UPDATE_COUNT,
  payload: countState,
});
